var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex justify-end p-8 cursor-pointer",on:{"click":_vm.handleClick}},[_c('p',{staticClass:"text-base"},[_vm._v(_vm._s(_vm.$t('rewards.reward_selection.a_z')))]),_c('Icon',{staticClass:"px-10 self-center",attrs:{"title":_vm.$t('rewards.reward_selection.a_z'),"iconClass":{
      'fas fa-angle-down': _vm.isSortedAsc,
      'fas fa-angle-up': !_vm.isSortedAsc,
    },"srText":_vm.srText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }